import { Card, CardActions, CardContent, CardHeader, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { ReactNode } from 'react';
import { TypographyVariant } from '@mui/material/styles/createTypography';

interface Props {
    children?: ReactNode;
    footer?: React.ReactNode;
    icon?: React.ReactNode;
    title?: React.ReactNode;
    hasTable?: boolean;
    sx?: SxProps<Theme>;
    onClick?: () => void;
    actions?: React.ReactNode;
    variant?: TypographyVariant;
}

export const Widget: React.FC<Props> = ({
    footer,
    icon,
    title,
    hasTable,
    sx = {},
    children,
    onClick,
    actions,
    variant = 'subtitle2',
}) => {
    return (
        <Card sx={sx} onClick={onClick} id="widget">
            {title && (
                <CardHeader
                    title={
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            spacing={1}
                            width="100%"
                            minHeight="35px"
                        >
                            <Stack direction="row" alignItems="center" spacing={2}>
                                {icon}
                                <Typography variant={variant}>{title}</Typography>
                            </Stack>

                            {actions}
                        </Stack>
                    }
                />
            )}
            <CardContent
                sx={
                    hasTable
                        ? {
                              p: 0,
                              '&:last-child': { pb: 0 },
                              '& .MuiDataGrid-root': {
                                  borderRadius: 0,
                                  border: 0,
                              },
                              '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
                                  borderBottom: 0,
                              },
                              '& .MuiDataGrid-footerContainer': {
                                  borderTop: 1,
                                  borderColor: 'lightGrey',
                              },
                              '.MuiDataGrid-columnHeaders': {
                                  fontSize: 'smaller',
                              },
                          }
                        : {
                              p: 2,
                          }
                }
            >
                {children}
            </CardContent>
            {footer && <CardActions>{footer}</CardActions>}
        </Card>
    );
};
